import React from 'react';

export const PageLoader = () => (
  <div className="flex min-h-[60vh] items-center justify-center" data-testid="page-loader">
    <div className="flex flex-col items-center gap-3">
      <div className="relative h-12 w-12">
        <span className="absolute inset-0 animate-ping rounded-xl bg-green-500/30" />
        <span className="absolute inset-0 flex items-center justify-center rounded-xl bg-green-600 text-sm font-extrabold text-white">
          R32
        </span>
      </div>
      <span className="text-xs text-gray-500">Se încarcă...</span>
    </div>
  </div>
);

export default PageLoader;
